export default {
  namespaced: true,
  state: {
    // 是否收起
    isCollapse: false,
    displayNav: true // 是否展示导航条
  },
  mutations: {
    // 更新是否收起的状态
    updateIsCollapse(state, isCollapse) {
      state.isCollapse = isCollapse
    }
  },
  actions: {
    // 更新是否收起的状态
    updateIsCollapse({ commit }, isCollapse) {
      commit('updateIsCollapse', isCollapse)
    }
  }
}
